import { decryptToAsciiString, encryptAsciiStringToHexString } from "../../dataEncryption";
import { collectLog, createEmptyLogsAndVars, dwReportError, recordVariable, } from "../../diagnostics/clientErrors";
const LOCALSTORAGE_KEY = "mpcWalletClientId";
export const hasSavedClientId = () => {
    return localStorage.getItem(LOCALSTORAGE_KEY) !== null;
};
export const storeClientId = async (provider, clientId) => {
    const encodedClientId = await encryptAsciiStringToHexString(provider, clientId);
    localStorage.setItem(LOCALSTORAGE_KEY, encodedClientId);
};
export const loadClientId = async (provider) => {
    const logsAndVars = createEmptyLogsAndVars("clientIdStorage:loadClientId");
    try {
        const encodedClientId = localStorage.getItem(LOCALSTORAGE_KEY);
        recordVariable(logsAndVars, "encodedClientId from localStorage", encodedClientId);
        if (encodedClientId === null) {
            return null;
        }
        else {
            collectLog(logsAndVars, "Trying to decrypt client id");
            return await decryptToAsciiString(provider, encodedClientId);
        }
    }
    catch (error) {
        dwReportError(null, undefined, error, { logsAndVars });
        return null;
    }
};
export const deleteClientId = async () => {
    localStorage.removeItem(LOCALSTORAGE_KEY);
};
